module.exports = __webpack_public_path__ + "img/9D602E_E4C363_D5A64F_C38A44-256px.dd50fc2c.png";